module.exports = __webpack_public_path__ + "static/media/cartbag.14cc8146.svg";